import * as S from './skeleton.styled'
import { SkeletonProps } from './skeleton.types'

export const Skeleton = ({
  variant = 'rectangular',
  width = '100%',
  height,
  mt,
  mb,
  ...props
}: SkeletonProps) => {
  return (
    <S.Skeleton
      {...props}
      $variant={variant}
      $width={width}
      $height={height}
      $mt={mt}
      $mb={mb}
      data-component-id="Skeleton"
    />
  )
}
